import { useEffect, useState } from "react";
import { collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db } from "../../config/firebaseConfig";
import Add from "./AddUser";
import "./users.css";

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const fetchUsers = async () => {
    try {
      const snapshot = await getDocs(collection(db, "users"));
      const usersList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Sorteer op firstname (case-insensitive)
      usersList.sort((a, b) =>
        a.firstname.localeCompare(b.firstname, "nl", { sensitivity: "base" })
      );

      setUsers(usersList);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const deleteUserWithId = async (id) => {
    try {
      await deleteDoc(doc(db, "users", id));
      fetchUsers();
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };

  const handleEdit = (user) => {
    setEditingUser(user);
    setIsAdding(true);
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="user-management">
      <div className="user-management-header">
        <h3>Gebruikers Beheer</h3>
        <span
          role="button"
          onClick={() => {
            setIsAdding(true);
            setEditingUser(null);
          }}
          className="add-button"
        >
          <span class="material-symbols-outlined">add_circle</span>
        </span>
      </div>
      <hr />

      <div className="user-grid">
        {users.map((user) => (
          <div className="user-card" key={user.id}>
            <div>
              <strong>Naam:</strong> {user.firstname} {user.lastname}
            </div>
            <div></div>
            <div>
              <strong>Email:</strong> {user.email}
            </div>
            <div></div>
            <div>
              <strong>Rol:</strong> {user.role}
            </div>
            <div className="user-buttons">
              <span
                role="button"
                onClick={() => handleEdit(user)}
                className="edit-button"
              >
                <span class="material-symbols-outlined">edit</span>
              </span>
              <span
                role="button"
                onClick={() => deleteUserWithId(user.id)}
                className="delete-button"
              >
                <span className="material-symbols-outlined">delete</span>
              </span>
            </div>
          </div>
        ))}
      </div>

      {isAdding && (
        <div className="modal-overlay">
          <div className="modal-content">
            {/* <button className="modal-close" onClick={() => setIsAdding(false)}>
              ×
            </button> */}
            <Add
              users={users}
              setUsers={setUsers}
              setIsAdding={setIsAdding}
              getUsers={fetchUsers}
              editingUser={editingUser}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
